import React from 'react';
import { IInvoiceFullObject } from '../Interfaces/IInvoice';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { InvoicePaidRow } from './InvoicePaidRow';
import { IInvoicePaid, invoicePaidSchema } from '../Interfaces/IInvoicePaid';

interface IProps {
  editInvoice: IInvoiceFullObject;
  setEditInvoice: Function;
  disableHelping?: boolean;
  children?: React.ReactElement | React.ReactElement[];
  markNewPaids?: boolean;
}

export const InvoicePaidTable: React.FC<IProps> = ({
  editInvoice,
  setEditInvoice,
  disableHelping,
  children,
  markNewPaids,
}) => {
  //const [invPaids,setInvPaids] = useState(editInvoice.InvoicePaids);
  const invPaids = editInvoice.InvoicePaids;
  const setInvPaids = (updatedArray: IInvoicePaid[]) => {
    setEditInvoice({
      ...editInvoice,
      InvoicePaids: updatedArray,
    });
  };

  const enableHelping =
    disableHelping === undefined || disableHelping === false;

  const showStatePartialPayment =
    invPaids.length > 0 &&
    editInvoice.idInvoiceState === 1 &&
    invPaids.map(paid => paid.PaidValue).reduce((a, b) => a + b, 0) > 0 &&
    invPaids.map(paid => paid.PaidValue).reduce((a, b) => a + b, 0) <
      Number(editInvoice.Total);

  const showStateTotalPayment =
    invPaids.length > 0 &&
    editInvoice.idInvoiceState < 10 &&
    invPaids.map(paid => paid.PaidValue).reduce((a, b) => a + b, 0) > 0 &&
    invPaids.map(paid => paid.PaidValue).reduce((a, b) => a + b, 0) >=
      Number(editInvoice.Total);

  const handleChangeState = (targetState: number) => {
    setEditInvoice({
      ...editInvoice,
      idInvoiceState: targetState,
    });
  };

  const handleAdd = () => {
    let idInvoicePaid = -1;

    if (invPaids.length > 0) {
      const minTmpId = Math.min(...invPaids.map(x => x.idInvoicePaid)) - 1;
      if (minTmpId <= idInvoicePaid) {
        idInvoicePaid = minTmpId - 1;
      }
    }

    const newObject = invoicePaidSchema.parse({ idInvoicePaid: idInvoicePaid });
    newObject.idInvoice = editInvoice.idInvoice;

    setInvPaids([...invPaids, newObject]);
  };

  return (
    <>
      <Typography>
        Zahlungen
        <Button sx={{ float: 'right' }} variant='outlined' onClick={handleAdd}>
          Zahlung hinzufügen
        </Button>
      </Typography>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell width={200}>Eingangsdatum</TableCell>
            <TableCell>Eingangssumme</TableCell>
            <TableCell width={110}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invPaids.map(invPaid => (
            <InvoicePaidRow
              key={`InvoicePaidRow-${invPaid.idInvoicePaid}`}
              invPaid={invPaid}
              invPaids={invPaids}
              setInvPaids={setInvPaids}
              markNewPaids={markNewPaids}
            />
          ))}
          <TableRow>
            <TableCell colSpan={3}>
              Eingegangene Zahlungen:
              <Typography sx={{ float: 'right', fontWeight: 'bold' }}>
                {invPaids
                  .map(paid => paid.PaidValue)
                  .reduce((a, b) => a + b, 0)
                  .toLocaleString('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                  })}
              </Typography>
            </TableCell>
          </TableRow>
          {children ? (
            children
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                Differenz zur Rechnungssumme:
                <Typography sx={{ float: 'right', fontWeight: 'bold' }}>
                  {(
                    invPaids
                      .map(paid => paid.PaidValue)
                      .reduce((a, b) => a + b, 0) - Number(editInvoice.Total)
                  ).toLocaleString('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                  })}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Collapse in={enableHelping && showStatePartialPayment}>
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography>Es ist eine Teilzahlung erfolgt.</Typography>
            <Typography>
              Wollen Sie die Rechnung auf den Status "Teilzahlung" setzen?
            </Typography>
          </CardContent>
          <CardActions
            disableSpacing
            sx={{
              alignSelf: 'stretch',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              p: 1,
            }}
          >
            <Button
              sx={{ float: 'right' }}
              onClick={() => handleChangeState(5)}
            >
              Status anpassen
            </Button>
          </CardActions>
        </Card>
      </Collapse>
      <Collapse in={enableHelping && showStateTotalPayment}>
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography>Die Rechnungsssumme liegt vollständig vor.</Typography>
            <Typography>
              Wollen Sie die Rechnung auf den Status "Gzahlt" setzen?
            </Typography>
          </CardContent>
          <CardActions
            disableSpacing
            sx={{
              alignSelf: 'stretch',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              p: 1,
            }}
          >
            <Button
              sx={{ float: 'right' }}
              onClick={() => handleChangeState(10)}
            >
              Status anpassen
            </Button>
          </CardActions>
        </Card>
      </Collapse>
    </>
  );
};
